import { ChangeEvent, InputHTMLAttributes, forwardRef } from "react";

import { InputStyle } from "./styles";

export type InputProps = {
  id: string;
  value?: string | null;
  onChangeValue?: (value: string) => void;
  hasError?: boolean;
  size?: "medium" | "large";
} & Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "id" | "size">;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      onChangeValue,
      className,
      style,
      hasError,
      disabled,
      size = "medium",
      onChange,
      ...restProps
    },
    ref
  ) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event);
      onChangeValue?.(event.target.value);
    };

    return (
      <InputStyle
        disabled={disabled}
        hasError={hasError}
        size={size}
        className={className}
        style={style}
      >
        <InputStyle.Input
          disabled={disabled}
          ref={ref}
          onChange={handleChange}
          aria-invalid={hasError ? "true" : "false"}
          {...restProps}
        />
      </InputStyle>
    );
  }
);

Input.displayName = "Input";
